import { OptionModel } from 'src/app/shared/models/optionModel';

export enum DateAccessedEnum {
  Specific = 1,
  Period = 2,
}

export const DateAccessedFilterConst: OptionModel[] = [
  new OptionModel('COMMON.SPECIFIC_DATE', DateAccessedEnum.Specific),
  new OptionModel('COMMON.PERIOD', DateAccessedEnum.Period),
];
